var SCM = SCM || {};

SCM.FocusRestore = (function ($) {
    const STORAGE_KEY = 'focusedElementSelector';
    const EXPIRATION_TIME_MS = 60 * 60 * 1000; // 1 hour
    const FOCUSIN_DELAY = 10;
    const KEYBOARD_FOCUS_DELAY = 100;
    const RESTORE_FOCUS_DELAY = 500;

    let lastFocusedSelector = null;
    let keyboardFocus = false;

    return {
        init: init
    };

    function init() {
        attachKeyboardListeners();
        attachKeyboardFocusHandler();
        attachBeforeUnloadHandler();
        restoreFocus();
    }

    function attachKeyboardListeners() {
        $(document).on('keydown', function (event) {
            if (event.key === 'Tab' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                keyboardFocus = true;
                SCM.wait(KEYBOARD_FOCUS_DELAY)
                    .then(() => {
                        keyboardFocus = false;
                    });
            }
        });
    }

    function attachKeyboardFocusHandler() {
        $(document).on('focusin', function () {
            SCM.wait(FOCUSIN_DELAY)
                .then(() => {
                    const focusedElement = document.activeElement;
                    if (keyboardFocus) {
                        lastFocusedSelector = generateCSSSelector(focusedElement);
                        storeFocusData(lastFocusedSelector);
                    }
                });
        });
    }

    function attachBeforeUnloadHandler() {
        $(window).on('beforeunload', function () {
            if (lastFocusedSelector) {
                storeFocusData(lastFocusedSelector);
            }
        });
    }
    
    function storeFocusData(selector) {
        const now = Date.now();
        const pageInfo = {
            selector: selector,
            url: window.location.href,
            expiration: now + EXPIRATION_TIME_MS
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(pageInfo));
    }

    function getFocusSelector() {
        const storedData = JSON.parse(localStorage.getItem(STORAGE_KEY));

        if (!storedData) {
            return null;
        }

        const now = Date.now();
        if (now >= storedData.expiration) {
            clearFocusData();
            return null;
        }
        
        if (storedData.url !== window.location.href) {
            clearFocusData();
            return null;
        }

        return storedData.selector;
    }

    function clearFocusData() {
        localStorage.removeItem(STORAGE_KEY);
    }

    function restoreFocus() {
        SCM.wait(RESTORE_FOCUS_DELAY)
            .then(() => {
                const focusedElementSelector = getFocusSelector();

                if (!focusedElementSelector || focusedElementSelector === 'document') {
                    return;
                }

                try {
                    const $elementToFocus = $(focusedElementSelector);

                    if ($elementToFocus.length) {
                        $elementToFocus.focus();
                    } else {
                        clearFocusData();
                    }
                } catch (error) {
                    clearFocusData();
                }
            });
    }

    function generateCSSSelector(element) {
        if (!element || element === document) {
            return 'document';
        }

        const parts = [];
        let current = element;

        while (current && current !== document) {
            const selectorPart = getSelectorPart(current);
            parts.unshift(selectorPart);

            if (current.id) {
                break;
            }

            current = current.parentNode;
        }

        return parts.join(' > ');
    }

    function getSelectorPart(element) {
        let selectorPart = element.tagName.toLowerCase();

        if (element.id) {
            selectorPart += `#${element.id}`;
        } else {
            const classes = getClassSelector(element);
            if (classes) {
                selectorPart += classes;
            }

            const nthChild = getNthChildSelector(element);
            if (nthChild) {
                selectorPart += nthChild;
            }
        }

        return selectorPart;
    }

    function getClassSelector(element) {
        const classes = Array.from(element.classList).filter(className => className !== 'focus-visible');
        return classes.length > 0 ? `.${classes.join('.')}` : '';
    }

    function getNthChildSelector(element) {
        const parent = element.parentNode;
        if (!parent) {
            return '';
        }

        const siblingsWithSameTagAndClasses = Array.from(parent.children).filter(
            sibling => sibling.tagName === element.tagName && haveSameClasses(sibling, element)
        );

        if (siblingsWithSameTagAndClasses.length > 1) {
            const index = Array.from(parent.children).indexOf(element) + 1;
            return `:nth-child(${index})`;
        }

        return '';
    }

    function haveSameClasses(element1, element2) {
        const classes1 = Array.from(element1.classList).sort().join('.');
        const classes2 = Array.from(element2.classList).sort().join('.');
        return classes1 === classes2;
    }
})(jQuery);